module.exports = __webpack_public_path__ + "img/ic_stop.659c8009.png";